import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AuthService, BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery } from '@fgb/core';
import { Router, NavigationStart } from '@angular/router';
import { firstValueFrom, Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  // ─── Page-state inputs ──────────────────────────────────────────────────────
  @Input() isHomePage: boolean = false;
  @Input() isTertiary: boolean = false;
  @Input() notDisplayNav: boolean = false;
  @Input() title: string;

  // Rewards page
  @Input() isPurchaseSuccessPage: boolean = false;
  @Input() isCheckOut: boolean;

  // Wallet page
  @Input() isWallet: boolean = false;
  @Input() isWalletItem: boolean = false;
  @Input() isClaimedPage: boolean = false;
  @Input() isCampaignPage: boolean = false;

  // ─── Observables ────────────────────────────────────────────────────────────
  memberDetails$: Observable<MemberDetails | undefined>;
  card$: Observable<MemberCard | undefined>;
  pointsBalance$: Observable<number | undefined>; // was loyaltyPointsCard$ — renamed to match template

  // ─── UI state ───────────────────────────────────────────────────────────────
  isCollapsed: boolean = false;
  isHelpOpen: boolean = false;

  private routerSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private router: Router,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private balanceQuery: BalanceQuery
  ) {}

  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);

    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => { this.isCollapsed = false; this.isHelpOpen = false; })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  logout() {
    firstValueFrom(this.authService.logout()).then(() => this.router.navigate(['/login']));
  }

  getDynamicRoute(): string[] {
    if (this.isPurchaseSuccessPage || this.isCheckOut) {
      return ['/rewards'];
    } else if (this.isWalletItem || this.isClaimedPage || this.isCampaignPage) {
      return ['/rewards/wallet'];
    } else if (this.isWallet || this.isTertiary) {
      return ['/'];
    } else {
      return ['/'];
    }
  }

  isRootRoute(): boolean {
    return this.getDynamicRoute()[0] === '/';
  }
}
